import type { Dispatch, ReactNode, SetStateAction } from 'react';
import { createContext, useContext, useEffect, useState } from 'react';

interface NewMessagesState {
	newMessages: string[];
	setNewMessages: Dispatch<SetStateAction<string[]>>;
}

const NewMessagesContext = createContext<NewMessagesState | null>({
	newMessages: [],
	setNewMessages: () => undefined,
});

export const useNewMessagesMeta = (): NewMessagesState => {
	const context = useContext(NewMessagesContext);
	if (context === null) {
		throw new Error(
			'Could not get new messages context. Did you forget to use NewMessagesProvider?'
		);
	}

	return context;
};

interface NewMessageMetaProviderProps {
	children: ReactNode;
}

export function NewMessagesProvider({ children }: NewMessageMetaProviderProps) {
	const [newMessages, setNewMessages] = useState<string[]>([]);
	const value: NewMessagesState = { newMessages, setNewMessages };

	useEffect(() => {
		return () => {
			setNewMessages([]);
		};
	}, []);

	return (
		<NewMessagesContext.Provider value={value}>
			{children}
		</NewMessagesContext.Provider>
	);
}
